module.exports = __webpack_public_path__ + "img/list-no-image-reserve.676279ea.svg";